import { Cookies } from 'react-cookie';

import { GroupedObject } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getClientsOnMap = async () => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get('/clients-map/', {
    headers: {
      Authorization: token,
    },
  });

  return data.data as GroupedObject[];
};
